import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import './styles/base.scss';

import Root from './containers/Root/Root';
import store from './redux/store/store';
import {isMocks} from './utils/utils';
import AuthenticationContainer
  from './containers/Authentication/AuthenticationContainer';
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

const rootElement = document.getElementById('root');
const renderedRoot = isMocks() ? (
    <Provider store={store}>
      <ErrorBoundary>
        <Root store={store} />
      </ErrorBoundary>
    </Provider>
  ) : (
  <Provider store={store}>
    <AuthenticationContainer store={store} />
  </Provider>);

if (rootElement) {
  ReactDOM.render(renderedRoot, rootElement);
} else {
  throw Error('HTML page is missing the required base element');
}
